import { Backdrop, CircularProgress, styled } from '@mui/material';

export const CustomBackdrop = styled(Backdrop)`
  background: #000000de;
`;

export const CustomCircularProgress = styled(CircularProgress)`
  color: #fff;
`;
